import { Component, OnInit }   from '@angular/core';
import { Router }              from '@angular/router';
import { UtilService } from '../service/util.service';
import { CookiesLocalService } from '../service/cookies-local.service';
import { ApplicantService } from '../service/applicant.service';
import { ToastrService } from 'ngx-toastr';
import { ComponentBase } from '../base/component-base';
import { BehaviorModelChangeService } from '../service/behavior-model-change.service.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogService } from '../service/dialog-service';

@Component({
  selector: 'app-postgraduate-programme-selection',
  templateUrl: './postgraduate-programme-selection.component.html',
  styleUrls: ['./postgraduate-programme-selection.component.css']
})
export class PostgraduateProgrammeSelectionComponent  extends ComponentBase implements OnInit {
  mainForm:FormGroup;
  programmes=[];
  title: string;
  postgraduateStudentTypes=[];

  fundings=[
            {Name:'Self Financing'},
            {Name:'Specially Sponsored or Fee Paying'},
            {Name:'Others'},
          ]

  constructor(private router: Router,private fb: FormBuilder, private utilService:UtilService
    ,applicantService:ApplicantService,cookieLocal:CookiesLocalService,private toastr:ToastrService,
    behaviorModelChangeService:BehaviorModelChangeService,private dialogService:DialogService) {
    super(applicantService,cookieLocal,behaviorModelChangeService);
  }
  ngOnInit() {
    this.title = 'Please select four programmes and respective funding.';

    this.loadData();
    this.mainForm = this.InitApplicantItems()

    this.applicantService.getPostgraduateApplicantProgrammeOfChoicesByApplicant(this.applicantData.ApplicationId)
    .subscribe(data=>{
      let model=data[0]
      if(model){
        this.mainForm = this.InitApplicantItems(model)
      }
    },error=>{
      console.log(error);
    });

  }

  
  InitApplicantItems(data:any=null){

   


    if(data){
      let appCert=this.fb.group({
        ApplicationId:[this.applicantData.ApplicationId],
        ProgrammeId: [data.ProgrammeId,Validators.required],
        PostgraduateStudentTypeId: [data.PostgraduateStudentTypeId,Validators.required],
        Reason: [data.Reason],
        AreaOfResearch: [data.AreaOfResearch],
        ProposedResearchTopic: [data.ProposedResearchTopic],
        AttachedProposedResearchOutlineFileName: [data.AttachedProposedResearchOutlineFileName],
        ProgrammeFundingId: [data.ProgrammeFundingId,Validators.required]
      }); 
  
      return appCert;
  
    }

    let appCert=this.fb.group({

      ApplicationId:[this.applicantData.ApplicationId],
      ProgrammeId: ['',Validators.required],
      PostgraduateStudentTypeId: ['',Validators.required],
      Reason: [''],
      AreaOfResearch: [''],
      ProposedResearchTopic: [''],
      AttachedProposedResearchOutlineFileName: [''],
      ProgrammeFundingId: ['',Validators.required],
    }); 

    return appCert;
  }


  loadData(){
    this.utilService.getProgrammes().subscribe(data => { 
      let programData=data.sort((a,b)=>a.ProgrammeFullName.localeCompare(b.ProgrammeFullName)).filter(s=>s.SchoolCentreId==2);
      this.programmes=programData.map(item=>
      {
          return {ValueId:item.ProgrammeId,DisplayValue:item.ProgrammeFullName.toUpperCase()};
      });
    }); 


    this.utilService.getPostgraduateStudentTypes().subscribe(data => { 
      
      this.postgraduateStudentTypes=data.map(item=>
      {
          return {ValueId:item.ValueId,DisplayValue:item.DisplayValue.toUpperCase()};
      });
    }); 

  }

  goToNext(form: any) {

    let model=form.value;

    if(this.isPostgraduateStudent()){

      this.applicantService.savePostgraduateApplicantProgrammeOfChoice([model])
        .subscribe(data=>{
          this.toastr.success('Applicant Programme saved successfully');

      });
      this.router.navigate(['/applicant/info/application-summary']);

    }

  }

  goToPrevious() {
    if(this.isPostgraduateStudent())
    this.router.navigate(['/applicant/info/post-research']);
  }


  
  isValidChoices(){
    return this.mainForm.valid;

  }



}
